export default __webpack_public_path__ + "static/media/DeveloperGuidelines_syncupstreammaster.a15272e7.png";